import { Suspense } from "react";
import { RouterProvider, createBrowserRouter, Outlet, ScrollRestoration } from "react-router-dom";

import GlobalErrorBoundary from "../page/GlobalErrorBoundary";

import MediaConfig from "../config/MediaConfig";
import MenuConfig from "../config/MenuConfig";
import BookmarkConfig from "../config/BookmarkConfig";
import ApmConfig from "../config/ApmConfig";

import DevAccess from "../context/DevContext";
import ResourceContext from "../context/ResourceContext";
import LabelContext from "../context/LabelContext";
import AppContext from "../context/AppContext";
import PageContext from "../context/PageContext";
import LayoutProvider from "../layout";

import { Main } from "@/tra/tancis/Main";

import SampleMain from "@/comn/sample/smpl-Main";
import { ComnMain } from "@/comn/comn/comn-Main";

import PortalMain from "../page/PortalMain";
import Login from "../page/Login";
import RemoteLogin from "../page/RemoteLogin";
import Idras2Tancis from "../page/Idras2Tancis";
import Registration from "../page/Registration";

//401
import Unauthorized from "../page/Unauthorized";
// 403
import Forbidden from "../page/Forbidden";
// 404
import NotFound from "../page/not-found";
// 405
import NotAllowed from "../page/not-allowed";
// 406
import NotAcceptable from "../page/not-acceptable";
// 500
import InternalServerError from "../page/internal-server-error";

import FindId from "../page/FindId";
import FindPassword from "../page/FindPassword";
import ChangePassword from "../page/ChangePassword";
import ReactivateAccount from "../page/ReactivateAccount";
import RenewalAccount from "@/comn/features/page/RenewalAccount";

import CommonModal from "@/comn/components/_/CommonModal";
import CommonToast from "@/comn/components/_/CommonToast";
import LoadingIndicator from "@/comn/components/_/LoadingIndicator";

import { DevRoutes } from "@/comn/features/router/Dev_Routes";
import { TancisRoutes } from "@/tra/tancis/Routes";

import Test from "@/comn/sample/Test/Test";
import Dashboard from "../page/Dashboard";
import DashboardTemp from "../page/DashboardTemp";

import { TimeoutConfig } from "../config/TimeoutConfig";
import {GlobalFeedbackModal} from "../layout/Reveiw/GlobalFeedbackModal";
import FindAccount from "../page/FindAccount";

export const routes: any = [...DevRoutes, ...TancisRoutes];

const createRoutes = () => {
    const routes = [
        { path: "/comn/smpl/*", element: <SampleMain /> },
        { path: "/comn/comn/*", element: <ComnMain /> },
        { path: "/findId", element: <FindAccount /> },
        // { path: "/findId", element: <FindId /> },
        // { path: "/findPassword", element: <FindPassword /> },
        { path: "/changePassword", element: <ChangePassword /> },
        { path: "/reactivateAccount", element: <ReactivateAccount /> },
        { path: "/renewalAccount", element: <RenewalAccount /> },
        { path: process.env.REACT_APP_BASE + "/401", element: <Unauthorized /> },
        { path: process.env.REACT_APP_BASE + "/403", element: <Forbidden /> },
        { path: process.env.REACT_APP_BASE + "/404", element: <NotFound /> },
        { path: process.env.REACT_APP_BASE + "/405", element: <NotAllowed /> },
        { path: process.env.REACT_APP_BASE + "/406", element: <NotAcceptable /> },
        { path: process.env.REACT_APP_BASE + "/500", element: <InternalServerError /> },
        { path: process.env.REACT_APP_BASE, element: <PortalMain /> },
        { path: "*", element: <Main /> },
    ];

    if (process.env.NODE_ENV === "development") {
        routes.push({ path: "/test/*", element: <Test /> });
    }

    if (process.env.REACT_APP_SYSTEM_GROUP === "tanesw") {
        routes.push({ path: "/registration", element: <Registration /> });
    }

    return routes;
};

const router = createBrowserRouter([
    {
        // Pre-configuration
        element: (
            <>
                <LabelContext.Provider>
                    <ResourceContext.Provider>
                        <MediaConfig />
                        <CommonToast />
                        <LoadingIndicator />
                        <div id="datepicker" style={{ zIndex: 10000, position: "absolute" }} />
                        <Outlet />
                    </ResourceContext.Provider>
                </LabelContext.Provider>
            </>
        ),
        // Global Error Boundary
        errorElement: <GlobalErrorBoundary />,
        children: [
            { path: "/dashboard/*", element: <Dashboard /> },
            { path: "/dashboardTemp/*", element: <DashboardTemp /> },
            { path: "/login", element: <Login /> },
            { path: "/remote-login", element: <RemoteLogin /> },
            { path: "/idras2tancis", element: <Idras2Tancis /> },
            {
                element: (
                    <AppContext.Provider>
                        <PageContext.Provider>
                            {/* <DevAccess> */}
                            {/* <LabelContext.Suspenser> */}
                            {/* <LabelContext.Fetcher> */}
                            <LayoutProvider>
                                <AppContext.Suspenser>
                                    <AppContext.Fetcher>
                                        <ApmConfig />

                                        {/* 2025-04-10 TRA */}
                                        <TimeoutConfig />
                                        <GlobalFeedbackModal/>
                                        <MenuConfig />
                                        <BookmarkConfig />

                                        <PageContext.Suspenser>
                                            <PageContext.Fetcher>
                                                <ScrollRestoration />
                                                <Suspense>
                                                    <Outlet />
                                                </Suspense>
                                                <CommonModal />
                                            </PageContext.Fetcher>
                                        </PageContext.Suspenser>
                                    </AppContext.Fetcher>
                                </AppContext.Suspenser>
                            </LayoutProvider>
                            {/* </LabelContext.Fetcher> */}
                            {/* </LabelContext.Suspenser> */}
                            {/* </DevAccess> */}
                        </PageContext.Provider>
                    </AppContext.Provider>
                ),
                children: createRoutes(),
            },
        ],
    },
]);

const Router = () => {
    return <RouterProvider router={router} />;
};

export default Router;
